import styled from 'styled-components';

export const PopoverButton = styled.button`
	background-color: white;
	color: ${(props) => props.color || 'black'};
	text-align: ${(props) => props.textAlign || 'center'};
	font-weight: ${(props) => props.fontWeight || 'normal'};
	border-right: none;
	border-left: none;
	border-top: none;
	border-bottom: 1px solid #c6c6c8;
	width: 130px;
	padding: 6px;
	&:hover {
		cursor: pointer;
	}
	&:last-child {
		border-bottom: none;
	}
	&:disabled {
		color: rgba(0, 0, 0, 0.25);
	}
`;
